import ReminderModal from './ReminderModal'; 
import NotificationWrapper from './NotificationWrapper';
import ReminderSvg from '../assets/images/svg/AlarmReminder.svg';
import DropdownItemsList from './DropdownItemsList';
import { CacheReminderData, DealStatusOptions, Socket, refershModule } from "../Context/AppActions";
import { Reminders } from '../components/ReminderPopUp/Reminders';
import React, { useState, useEffect, useRef, useContext, createContext } from "react"; 
import { 
  Form,
  FormControl, 
  FormGroup, 
} from "react-bootstrap"; 
 
import { Popover as AntdPopover, Collapse, message } from "antd"; 
import "../common/header/header.css";
import { convertToUSTime} from "../components/HR/TimeClock/Util"; 
import "../common/style.css";
import { faClock, faCog, faSearch, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import 'moment-timezone'; 
import "bootstrap/dist/js/bootstrap"; 
import "bootstrap/dist/css/bootstrap.min.css"; 
import "bootstrap/js/src/dropdown"; 
import "../App.css";   
import _ from "lodash";   
import AwsServerService from "../common/util/AwsServerService";  
import { getStatusOptions } from "../tabs/Task/TaskUtil";  
import AppContext from '../Context/AppContext';
import { useDispatch, useSelector } from "react-redux";
import { getSocket } from '../Socket';
import ClockInTime from '../ClockInTime';
import { setrefreshTimeClock, setCacheReminderData, setDealStatusOptions, setRefershModule, } from '../Context/ReduxContext';
import { canAccess } from '../common/util/appUtils';
import moment from 'moment/moment';

export default function TimeRemNotification({currentUser, history}) { 
    const [appRefreshed, setAppRefreshed] = useState(false); 
    const AppData = useContext(AppContext);
    const accessContext = useSelector(state => state.UserContext.accessContext);
    const canViewSetting = canAccess(accessContext, "Settings", "View")
    const { dispatch ,state} = AppData || {};   
    const reduxDispatch = useDispatch();
    const socket = getSocket(); 
    const [refreshTimeclock, setRefreshTimeclock] = useState(false);
    const [pullNotificationsFlag, setPullNotificationsFlag] = useState(false);
    const [helperOpsData, setHelperOpsData] = useState([]); 
    const [openReminderListModal, setOpenReminderListModal] = useState(false); 
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    const [allReminderData,setAllReminderData] = useState([]);
    const [notificationFilter, setNotifcationFilter] = useState([
        { name: "TASK", isVisible: true, isSearch: true , settingObj:{active:true,lastDisableTime:null,lastActiveTime:null} },
        { name: "MENTION", isVisible: true, isSearch: true, settingObj:{active:true,lastDisableTime:null,lastActiveTime:null} },
        { name: "NOTES", isVisible: true, isSearch: true ,settingObj:{active:true,lastDisableTime:null,lastActiveTime:null}},
        { name: "ASSIGNEE", isVisible: true, isSearch: true ,settingObj:{active:true,lastDisableTime:null,lastActiveTime:null}},
        // { name: "REMINDER", isVisible: true, isSearch: true ,settingObj:{active:true,lastDisableTime:null,lastActiveTime:null}},
        // { name: "MESSAGE", isVisible: true, isSearch: true ,settingObj:{active:true,lastDisableTime:null,lastActiveTime:null}},
        { name: "ATTACHMENT", isVisible: true, isSearch: true,settingObj:{active:true,lastDisableTime:null,lastActiveTime:null}},
        { name: "BUG", isVisible: true, isSearch: true,settingObj:{active:true,lastDisableTime:null,lastActiveTime:null} },
    ]);
    const [triggeredReminders,setTriggeredReminders] = useState([]);
    const [allReminderDataObject,setAllReminderDataObject] = useState({});
    const [clockisActive, setClockIsActive] = useState(false);
    const reminderDataTemplate={ "At specific time":{ active:[],  inactive:[], },
    "On every reply":{ active:[], inactive:[], },
    "If no replies until":{  active:[], inactive:[], }, }
    
    useEffect(e=>{  
        setAppRefreshed(true);
        fetchReminders();
        getStatusOptions().then(res=>{
            reduxDispatch(setDealStatusOptions(res));
        })
        fetchHelperOpsData();
    },[]);

    useEffect(() => {
      reduxDispatch(setrefreshTimeClock(refreshTimeclock));
    }, [refreshTimeclock]);

    function modifyReminders(data){
        let arr={...reminderDataTemplate}
        let triggerArray=[]
        data.map(d=>{
            if(d.triggered=="true" && d.status!="true" && d.attendees?.includes(userInfo?.email_id)){
                triggerArray.push(d);
            }
      let obj=arr[d.reminderType];
      if(obj){
        if(d.status!="true"){
          obj.active?.push(d);
        }else{
          obj.inactive?.push(d);
        }
      }
    })
    triggerArray=triggerArray?.sort((a,b)=>new Date(b)-new Date(a));
    setTriggeredReminders(triggerArray.filter(d=>d.sendAs.toLowerCase()=="popup"));
    setAllReminderDataObject(arr);
  }
   useEffect(e=>{
       
      try{
        if(state?.socket?.trigger && !state?.socket?.data){
          socket.emit(state.socket.trigger,"")
        }else if(state?.socket?.trigger && state?.socket?.data){
          if(state?.socket?.trigger=="Check_Reply_Reminder"){
            let activData=[...allReminderData];
            if(activData && activData.length>0){
              let isReply = activData.find(d=>d.messageId==state?.socket?.data && d.reminderType=="On every reply" && d.status=="false");
              if(isReply){
                socket.emit(state?.socket?.trigger,isReply);
              }
            }
          }else{
            socket.emit(state?.socket?.trigger,state?.socket?.data);
          }
        }
      }catch(e){
        console.error(e);
      }
      dispatch(Socket(null))
    },[state?.socket])
    
    function reminderSchedular(flag,data){ 
    if(flag=="On every reply"){
      // UpdateReminder([{ROWID:data.ROWID,triggered:"true"}],true)
      fetchReminders();
      setOpenReminderListModal({status:true,data:null})
    }else if(flag=="Trigger From Server"){
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      fetchReminders();
      if(data && data?.find(r=>r.attendees.includes(userinfo.email_id))){
        setOpenReminderListModal({status:true,data:null});
      }
    }
  }
  async function handleSettingChange(e,module,index){
      let temp=[...notificationFilter];
      // setLoader(true);
       
      if(e){
        temp[index].settingObj.active=true;
        temp[index].settingObj.lastActiveTime=convertToUSTime(new Date());
      }else{
        temp[index].settingObj.active=false;
        temp[index].settingObj.lastDisableTime=convertToUSTime(new Date());
      }
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      // setLoader(true);
      if(helperOpsData.find(d=>d.module=="NotificationFilter" && d.userId==userinfo.email_id)){
        await AwsServerService.DeleteHelperOps([userinfo.email_id],{module:"NotificationFilter"}).then(async res=>{
          await AwsServerService.SaveHelperOps(notificationFilter,"NotificationFilter",userinfo.email_id);
          // setLoader(false)
        }).catch(e=>{
          console.error(e);
          // setLoader(false)
        })
      }else{
        await AwsServerService.SaveHelperOps(notificationFilter,"NotificationFilter",userinfo.email_id).then(res=>{
          // setLoader(false)
        }).catch(e=>{
          // setLoader(false)
          console.error(e);
        })
      }
      // setNotifcationFilter(temp);
    }
    
 useEffect(e=>{ 
    socket.on("Refresh_Reminder_List",(data)=>{
      setPullNotificationsFlag(!pullNotificationsFlag)
      fetchReminders();
    })  
    socket.on("Refresh_Module",(data)=>{
          if(data?.module=="NotificationFilter" && data?.userId==userInfo.email_id){
            fetchHelperOpsData();
          }else if(data=="Refresh_Chat"){
            setPullNotificationsFlag(!pullNotificationsFlag)
            reduxDispatch(setRefershModule({module:"Refresh_Chat",data:data}));
          }
        })
    socket.on("Check_Reply_Reminder",(data)=>{
      setPullNotificationsFlag(!pullNotificationsFlag)
      reminderSchedular("On every reply",data)
    })
    socket.on("Reminders_Notification",(data)=>{ 
      setPullNotificationsFlag(!pullNotificationsFlag)
      reminderSchedular("Trigger From Server",data)
    })  
   },[])

  async function fetchReminders(){
      let user=JSON.parse(localStorage.getItem("userinfo"));
      await AwsServerService.GetReminders().then(res=>{
        // if(res?.data && res.data.length>0){
          setAllReminderData(res.data);
          reduxDispatch(setCacheReminderData(res.data));
          res.data = res.data?.filter(d=>d?.attendees?.includes(user?.email_id));
          modifyReminders(res.data);
          res.data = res.data?.sort((a, b) => new Date(b.reminderTime) - new Date(a.reminderTime));
       // }
      }).catch(e=>{
        console.error(e);
      })
    }
    async function fetchHelperOpsData(){ 
        await AwsServerService.GetHelperOps().then(res=>{
          setHelperOpsData(res.data);
          let tempNotificationFilters=res?.data?.find(d=>d.module=="NotificationFilter" && d.userId==userInfo.email_id);
          if(tempNotificationFilters && tempNotificationFilters.jsonData){
            // let arr=[...notificationFilter,...tempNotificationFilters.jsonData];
            setNotifcationFilter(tempNotificationFilters.jsonData);
          }
        }).catch(e=>{
          console.error(e);
        })
      } 
      const content = (
          <div
            className="dropdown-menu dropdown-menu-right accountexpansion"
            aria-labelledby="dropdownMenuButton"
          >
            <div>
              <img src={localStorage.getItem("ProfilePhoto")} className="user-ico" />
              <div className="user-details-box">
                <span className="username">
                  {currentUser
                    ? currentUser.first_name + " " + currentUser.last_name
                    : "NA"}
                </span>
                <span className="useremail">
                  {currentUser ? currentUser.email_id : "NA"}
                </span>
                <span className="userrole">
                  {currentUser ? currentUser.role_details.role_name : "NA"}
                </span>
              </div>
            </div>
            <div className="navAccountMenu-bottom ">
              <a
                className="logout"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (window.confirm("Are you sure you want to logout?")) {
                    window.catalyst.auth.signOut("/");
                    localStorage.clear();
                  }
                }}
              >
                <FontAwesomeIcon icon={faSignOutAlt} />  Logout
              </a>
      
              <a
                className="setting"
                aria-disabled={false}
                style={{ cursor: canViewSetting ? "pointer" : "not-allowed" }}
                onClick={() =>{
                  if(!canViewSetting){
                    message.error("Permission Denied");
                    return;
                  }
                  history.push({ pathname: "/setting/index" })
                } }
              >
                <FontAwesomeIcon icon={faCog} /> Settings
              </a>
            </div>
          </div>
        );
  return (<>
           <ReminderModal 
            history={history}
              openReminderListModal={openReminderListModal}
              setOpenReminderListModal={setOpenReminderListModal}
            allReminderData={allReminderData}
            triggeredReminders={triggeredReminders}
            setTriggeredReminders={setTriggeredReminders}
            allReminderDataObject={allReminderDataObject}
          />
          <Form inline>
                    <FormGroup
                      className="display-none"
                    >
                      <FormControl
                        type="text"
                        placeholder="Search"
                        className="mr-sm-2 pad-fix search-header"
                      />
                      <FontAwesomeIcon
                        className="fontawsome-text mar-right-20 header-search-icon"
                        icon={faSearch}
                      />
                    </FormGroup> 
                    <FontAwesomeIcon
                      className="fontawsome-text mar-right-20"
                      icon={faSearch}
                    /> 
                    <div
                      className={
                        clockisActive
                          ? "clock-button clock-red"
                          : "clock-button clock-green"
                      }
                      onClick={()=>{
                        setAppRefreshed(false)
                        setClockIsActive(!clockisActive)
                      }}
                    >
                      <span>Check-{clockisActive ? "out" : "in"}</span>
                      <FontAwesomeIcon
                        className={
                          clockisActive
                            ? "clockicon-align-red"
                            : "clockicon-align-green"
                        }
                        icon={faClock}
                      />
                      <div> {clockisActive ? <ClockInTime refreshTimeclock={refreshTimeclock} 
                      setRefreshTimeclock={setRefreshTimeclock}
                      appRefreshed={appRefreshed} userInfo={userInfo} 
                      clockisActive={clockisActive} setClockIsActive={setClockIsActive}/> 
                      :<ClockInTime refreshTimeclock={refreshTimeclock} 
                      setRefreshTimeclock={setRefreshTimeclock} appRefreshed={appRefreshed} userInfo={userInfo}
                      clockisActive={clockisActive} setClockIsActive={setClockIsActive}/>}</div>
                    </div>
                    <div style={{display:"flex",position:"relative"}}>
                      <Reminders
                        history={history}
                        title={"Reminders"}
                        data={allReminderData}
                      >
                        <div className={`Reminder-Icon-Header ${allReminderData?.filter(e=>e.status!="true" && e.triggered=="true" && e.userEmail==userInfo.email_id )?.length>0 ? 'has-alarm' : ''}`}
                          // onClick={e=>{
                          //   setOpenReminderListModal({status:true,data:""});
                          // }}
                        >
                          <i className={`alarm-icon`}></i>
                          <img src={ReminderSvg}></img>
                          <span className="notification-count">
                            {allReminderData?.filter(d => (d.status == "false" && d.triggered == "true" && d.userEmail==userInfo.email_id && !moment(d.reminderTime).isBefore(moment().startOf("day"))))?.length > 0 ? allReminderData.filter(d => (d.status == "false" && d.userEmail==userInfo.email_id && d.triggered == "true" && d.userEmail==userInfo.email_id && !moment(d.reminderTime).isBefore(moment().startOf("day"))))?.length : ""}
                              {/* {allReminderData?.filter(e=>e.status!="true" && e.userEmail==userInfo.email_id)?.length>0?allReminderData.filter(e=>e.status!="true" && e.userEmail==userInfo.email_id)?.length:''} */}
                          </span>
                        </div>
                      </Reminders>
                    </div>
                   <NotificationWrapper
                   pullNotificationsFlag={pullNotificationsFlag} 
                   history={history}
                   handleSettingChange={handleSettingChange} 
                   notificationFilter={notificationFilter} 
                   setNotifcationFilter={setNotifcationFilter}  
                   userInfo={userInfo}
                    />
                    <DropdownItemsList history={history} />
                    <AntdPopover
                      style={{ zIndex: 9999 }}
                      trigger="click"
                      placement="bottomLeft"
                      content={content}
                      arrow={false}
                    >
                      {localStorage.getItem("ProfilePhoto") ? (
                        <img
                          type="button"
                          id="dropdownMenuButton"
                          src={localStorage.getItem("ProfilePhoto")}
                          className="user-ico"
                        />
                      ) : (
                        <div
                          className="no-image-user"
                          type="button"
                          id="dropdownMenuButton"
                        >
                          {currentUser ? currentUser.first_name.charAt(0) : "NA"}
                        </div>
                      )}
                    </AntdPopover>
                  </Form>
                  </>
  )
}
